import AdminLayoutSideBarItem from "./AdminLayoutSideBarItem";
import {
  Category,
  Home,
  StatusUp,
  Video,
  Notepad,
  Book,
  Teacher,
  EmptyWallet,
  UserSearch,
  Message,
  InfoCircle,
  MessageQuestion,
  Logout,
  DocumentText1,
  Chart,
} from "iconsax-reactjs";

interface SidebarItem {
  id: string;
  label: string;
  icon?: React.ReactNode;
  path?: string;
  notifition?: string;
  children?: SidebarItem[];
}

const sidebarData: SidebarItem[] = [
  {
    id: "dashboard",
    label: "داشبورد",
    icon: <Category variant="Outline" size={24} />,
    path: "/",
    notifition: "",
    children: [],
  },
  {
    id: "stats",
    label: "آمار",
    icon: <Chart variant="Outline" size={24} />,
    path: "/stats",
    notifition: "",
    children: [],
  },
  {
    id: "category",
    label: "مدیریت دسته بندی",
    icon: <StatusUp variant="Outline" size={24} />,
    path: "",
    notifition: "",
    children: [
      {
        id: "category-list",
        label: "لیست دسته بندی",
        path: "/category",
        notifition: "",
      },
      {
        id: "category-create",
        label: "ایجاد دسته بندی جدید",
        path: "/add-category",
        notifition: "",
      },
    ],
  },
  {
    id: "landing",
    label: "لندینگ",
    icon: <Home variant="Outline" size={24} />,
    path: "",
    notifition: "",
    children: [
      {
        id: "landing-story",
        label: "مدیریت استوری",
        path: "/story",
        notifition: "",
      },
      {
        id: "landing-video",
        label: "مدیریت ویدیو",
        path: "/video",
        notifition: "",
      },
      {
        id: "landing-banner",
        label: "مدیریت بنر اصلی",
        path: "/banner",
        notifition: "",
      },
    ],
  },
  {
    id: "post",
    label: "مدیریت پست‌ها",
    icon: <DocumentText1 variant="Outline" size={24} />,
    path: "/post",
    notifition: "",
    children: [],
  },
  {
    id: "article",
    label: "مدیریت مقالات",
    icon: <Book variant="Outline" size={24} />,
    path: "/article",
    notifition: "",
    children: [],
  },
  {
    id: "event",
    label: "مدیریت رویدادها",
    icon: <Teacher variant="Outline" size={24} />,
    path: "/event",
    notifition: "",
    children: [],
  },
  {
    id: "courses",
    label: "مدیریت دوره‌ها",
    icon: <Notepad variant="Outline" size={24} />,
    path: "/course",
    notifition: "inprogress-courses pending-courses",
    children: [],
  },
  {
    id: "payout",
    label: "مدیریت مالی",
    icon: <EmptyWallet variant="Outline" size={24} />,
    path: "/payout",
    notifition: "payouts",
    children: [],
  },
  {
    id: "skyroom",
    label: "اسکای روم",
    icon: <Video variant="Outline" size={24} />,
    path: "/skyroom",
    notifition: "",
    children: [],
  },
  {
    id: "user",
    label: "لیست کاربران",
    icon: <UserSearch variant="Outline" size={24} />,
    path: "/user",
    notifition: "",
    children: [],
  },
  {
    id: "tickets",
    label: "پشتیبانی",
    icon: <InfoCircle variant="Outline" size={24} />,
    path: "/ticket",
    notifition: "pending-tickets",
    children: [],
  },
  {
    id: "report",
    label: "گزارشات",
    icon: <MessageQuestion variant="Outline" size={24} />,
    path: "/report",
    notifition: "",
    children: [],
  },
  {
    id: "message",
    label: "ارسال پیام",
    icon: <Message variant="Outline" size={24} />,
    path: "/message",
    notifition: "",
    children: [],
  },
  {
    id: "logout",
    label: "خروج از حساب",
    icon: <Logout variant="Outline" size={24} />,
    path: "",
    notifition: "",
    children: [],
  },
];

export default function AdminLayoutSideBar() {
  const notifications = [""];

  return (
    <aside>
      {sidebarData.map((item) => (
        <AdminLayoutSideBarItem
          key={item.id}
          item={item}
          notifications={notifications}
        />
      ))}
    </aside>
  );
}
